var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getTool = exports.DefaultTools = void 0;
    exports.DefaultTools = [
        {
            code: 'freehand',
            name: 'Freehand',
            icon: 'FH',
            childTools: [
                {
                    code: 'freehand-freehand',
                    name: 'Freehand',
                    icon: 'FREE',
                    toolFactory: (extension) => {
                        debugger;
                        // @ts-ignore
                        return new Autodesk.Viewing.Extensions.Markups.Core.EditModeFreehand(extension);
                    },
                },
                // {
                //     code: 'freehand-no-smooth',
                //     name: 'Freehand no smooth',
                //     icon: 'FHNS',
                //     toolFactory: (extension) => {
                //         // @ts-ignore
                //         const em = new Autodesk.Viewing.Extensions.Markups.Core.EditModeFreehand(extension);
                //         em.smoothen = false;
                //         return em;
                //     },
                // },
                {
                    code: 'freehand-highlight',
                    name: 'Highlight',
                    icon: 'HIGH',
                    toolFactory: (extension) => {
                        // @ts-ignore
                        return new Autodesk.Viewing.Extensions.Markups.Core.EditModeHighlight(extension);
                    },
                },
            ],
        },
        {
            code: 'shapes',
            name: 'Shapes',
            icon: 'SHP',
            childTools: [
                {
                    code: 'shapes-circle',
                    name: 'Circle',
                    icon: 'CIRC',
                    toolFactory: (extension) => {
                        // @ts-ignore
                        return new Autodesk.Viewing.Extensions.Markups.Core.EditModeCircle(extension);
                    },
                },
                {
                    code: 'shapes-rectangle',
                    name: 'Rectangle',
                    icon: 'RECT',
                    toolFactory: (extension) => {
                        // @ts-ignore
                        return new Autodesk.Viewing.Extensions.Markups.Core.EditModeRectangle(extension);
                    },
                },
                // {
                //     code: 'shapes-polyline',
                //     name: 'Polyline',
                //     icon: 'POL',
                //     toolFactory: (extension) => {
                //         // @ts-ignore
                //         return new Autodesk.Viewing.Extensions.Markups.Core.EditModePolyline(extension);
                //     },
                // },
                {
                    code: 'shapes-line',
                    name: 'Line',
                    icon: 'MINUS',
                    toolFactory: (extension) => {
                        // @ts-ignore
                        return new Autodesk.Viewing.Extensions.Markups.Core.EditModePolyline(extension);
                    },
                },
                {
                    code: 'shapes-x',
                    name: 'X',
                    icon: 'CROSS',
                },
            ],
        },
        {
            code: 'cloud',
            name: 'Cloud',
            icon: 'CLD',
            childTools: [
                {
                    code: 'cloud-cloud',
                    name: 'Cloud',
                    icon: 'CLD',
                    toolFactory: (extension) => {
                        // @ts-ignore
                        return new Autodesk.Viewing.Extensions.Markups.Core.EditModeCloud(extension);
                    },
                },
                {
                    code: 'cloud-polycloud',
                    name: 'Polycloud',
                    icon: 'PCLD',
                    toolFactory: (extension) => {
                        // @ts-ignore
                        return new Autodesk.Viewing.Extensions.Markups.Core.EditModePolycloud(extension);
                    },
                },
            ],
        },
        {
            code: 'arrow',
            name: 'Arrow',
            icon: 'ARR',
            toolFactory: (extension) => {
                // @ts-ignore
                return new Autodesk.Viewing.Extensions.Markups.Core.EditModeArrow(extension);
            },
        },
        {
            code: 'dimension',
            name: 'Dimension',
            icon: 'DIM',
            toolFactory: (extension) => {
                // @ts-ignore
                return new Autodesk.Viewing.Extensions.Markups.Core.EditModeDimension(extension);
            },
        },
        {
            code: 'text',
            name: 'Text',
            icon: 'TXT',
            childTools: [
                {
                    code: 'text-text',
                    name: 'Text',
                    icon: 'TXT',
                    toolFactory: (extension) => {
                        // @ts-ignore
                        return new Autodesk.Viewing.Extensions.Markups.Core.EditModeText(extension);
                    },
                },
                {
                    code: 'text-callout',
                    name: 'Callout',
                    icon: 'CALL',
                    toolFactory: (extension) => {
                        // @ts-ignore
                        return new Autodesk.Viewing.Extensions.Markups.Core.EditModeCallout(extension);
                    },
                },
            ],
        },
        {
            code: 'link',
            name: 'Link',
            icon: 'LINK',
            childTools: [
                {
                    code: 'link-ellipse',
                    name: 'Ellipse',
                    icon: 'CIRC2',
                },
                {
                    code: 'text-callout',
                    name: 'Callout',
                    icon: 'SQR',
                },
                {
                    code: 'cloud-cloud',
                    name: 'Cloud',
                    icon: 'CLD',
                },
            ],
        },
        {
            code: 'ticket',
            name: 'Ticket',
            icon: 'TCKT',
            toolFactory: (extension) => {
                // @ts-ignore
                return new Autodesk.Viewing.Extensions.Markups.Core.EditModeArrow(extension);
            },
        },
        {
            code: 'color',
            name: 'Color',
        },
    ];
    const getTool = (markupsExtension, toolDef) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        return (_a = toolDef.toolFactory) === null || _a === void 0 ? void 0 : _a.call(toolDef, markupsExtension);
    });
    exports.getTool = getTool;
});
//# sourceMappingURL=Tools.js.map